import { Component, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AsyncPipe, NgClass, NgForOf, NgIf } from '@angular/common';
import { MetaPaginationComponent } from '@shared-components/meta-pagination/meta-pagination.component';
import { CommonApplicationUsersComponent } from '@directory/components/common-application-users.component';
import { User } from '@models/account/user.model';

@Component({
  selector: 'app-application-users',
  standalone: true,
  imports: [FormsModule, NgClass, AsyncPipe, NgForOf, MetaPaginationComponent, NgIf],
  templateUrl: './application-users.component.html',
  styles: ``,
})
export class ApplicationUsersComponent extends CommonApplicationUsersComponent {
  @Output() emitter = new EventEmitter<User>();
}
